export const otpCodeFieldName = 'oc-n';
